module.exports = __webpack_public_path__ + "media/images/icon_party-280b93a9ba286a908b1708f958e306ce.svg";